import React, { useEffect, useState } from "react";

import {
  usePrivacyContext,
} from "../context/PrivacyContext";


export function PrivacyBanner(){

  const {
    hasConsent,
    updateConsent,
    openPreferences,
    translations,
  } = usePrivacyContext();


  const [mounted, setMounted] = useState(false);


  useEffect(() => {

    setMounted(true);

  }, []);



  if(!mounted){

    return null;

  }



  if(hasConsent){

    return null;

  }




  function acceptAll(){

    updateConsent({

      necessary:true,

      analytics:true,

      marketing:true,

      preferences:true,

    });

  }





  function rejectAll(){

    updateConsent({

      necessary:true,

      analytics:false,

      marketing:false,

      preferences:false,

    });

  }





  return (

    <div className="privacy-banner">

      <p className="privacy-banner-text">

        {translations.bannerMessage}

      </p>


      <div className="privacy-actions">


        <button
          className="privacy-accept"
          onClick={acceptAll}
        >
          {translations.acceptAll}
        </button>


        <button
          className="privacy-reject"
          onClick={rejectAll}
        >
          {translations.rejectAll}
        </button>


        <button
          className="privacy-settings"
          onClick={openPreferences}
        >
          {translations.customize}
        </button>


      </div>

    </div>

  );

}